import { ChangeDetectorRef, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AppointmentDetail } from 'projects/Administration/src/app/business-entities/appointmentDetail-model';
import * as Enums from '../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { DocumentPartStatus } from 'projects/Administration/src/app/business-entities/appointmentStatus-model';
import { AppointmentService } from '../../../../../business-services/appointment.service';
import { BrandViewModel } from 'projects/Widget/src/app/business-entities/brand.interface';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentWorkOrderService } from 'projects/Administration/src/app/business-services/appointment-work-order.service';
import { Features } from 'projects/Widget/src/app/business-entities/step.class';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnholdStatusChangeComponent } from 'projects/Administration/src/app/components/onhold-status-change/onhold-status-change.component';
import { CancelStatusChangeComponent } from 'projects/Administration/src/app/components/cancel-status-change/cancel-status-change.component';
import { Subscription } from 'rxjs';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CultureLocaleService } from 'projects/Administration/src/app/services/culture-locale.service';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { AppointmentCommonService } from 'projects/Administration/src/app/business-services/appointment-common.service';
import { AppLinkService } from 'projects/Administration/src/app/business-services/app-link.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from 'projects/Administration/src/app/business-services/setting.service';

@Component({
  selector: 'app-work-order-general-info',
  templateUrl: './work-order-general-info.component.html',
  styleUrls: ['./work-order-general-info.component.css']
})
export class WorkOrderGeneralInfoComponent implements OnInit {
  previousStatus: any;
  isQuote: boolean = false;
  SelectedStatus: any = null;
  StatusDisabled: boolean = false;
  isRentalService: boolean = false;
  isRentalCar: boolean = false;
  previousDocumentStatus: any;
  isShareBoxEnabled: boolean = false;
  featureList: Features[] = [];
  RentalCarModel: any;
  RentalCarPrice: any;
  genericRentalCar: boolean = false;
  IsDisableBookedDate: boolean = true;
  brandList: BrandViewModel[];
  StartDate;
  IsonHoldStatus: boolean = false;
  AppointmentHour: number;
  AppointmentMinutes: number;
  IsActive: boolean = true;
  isShowGenerateTrackerButton: boolean = false;
  isDocumentPartStatusActive: boolean = false;
  isShiftAppointment: boolean = false;
  isDMSEnable: boolean = false;
  shiftDealerId: string;
  salesPersonList = []
  currentlagSub: Subscription;
  remark: string = '';
  documentPartStatus: DocumentPartStatus[];
  CountryISO = CountryISO;
  isInitialLoad: boolean = true;
  onlyCountries: string[] = [];
  countryDialCodes: any[] = [];
  isOfferFeatureActive:any;
  selectedCountryISO = this.cultureLocaleService.getLocale() || CountryISO.Norway;
  @Output() onGetContactDetails = new EventEmitter<AppointmentDetail>();
  @Output() isRefreshTab = new EventEmitter<boolean>();
  @Output() onShiftAppointment = new EventEmitter<any>();
  @Output() updatedAppointmentDetails = new EventEmitter<AppointmentDetail>();
  constructor(
    private readonly appointmentService: AppointmentService,
    private readonly spinner: NgxSpinnerService,
    public workOrderService: AppointmentWorkOrderService,
    private readonly modalService: NgbModal,
    private readonly currentLanguageService: CurrentLanguage,
    private readonly secureStorage: SecureStorage,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService,
    public commonService: AppointmentCommonService,
    public appLinkService: AppLinkService,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly settingService: SettingService
  ) { }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList?.length > 0) {
        this.isRentalService = this.featureList.find(x => x.featureCode === Enums.FeatureCode.RenatlCar)?.isActive
        this.genericRentalCar = this.featureList.find(x => x.featureCode === Enums.FeatureCode.GRentalCar)?.isActive;
        this.isDocumentPartStatusActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DocumentPartStatus)?.isActive;
        this.isShiftAppointment = this.featureList.find(x => x.featureCode === Enums.FeatureCode.ShiftAppointment)?.isActive;
        this.isShareBoxEnabled = this.featureList.find(x => x.featureCode === Enums.FeatureCode.ShareBox)?.isActive;
        this.isDMSEnable = this.featureList.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        this.isOfferFeatureActive = this.featureList.find(x => x.featureCode === Enums.FeatureCode.OFFER)?.isActive;
      }
    }
    this.GetAll();

    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(x => {
      this.getStatusBrand(this.commonService.editAppointmentService.appointmentDetails.dealerId, this.commonService.editAppointmentService.appointmentDetails.id, x);
    });
  }
  async GetAll() {
    this.commonService.appointmentDetails = this.commonService.editAppointmentService.appointmentDetails;
    if (this.commonService.appointmentDetails?.workOrderStatusId) {
      if (this.commonService.appointmentDetails.workOrderStatusId === Enums.WOStatus.Closed || this.commonService.appointmentDetails.workOrderStatusId === Enums.WOStatus.Cancelled) {
        this.SelectedStatus = this.commonService.appointmentDetails.workOrderStatusId;
        this.StatusDisabled = true;
      }
      else {
        this.SelectedStatus = null;
      }
    }
    if (this.commonService.editAppointmentService.appointmentDetails.appointmentType == "Quote") {
      this.isQuote = true;
    }
    this.commonService.appointmentStatusName = this.commonService.appointmentDetails.appointmentStatus;
    this.commonService.SelectedDocumentPartStatus = this.commonService.appointmentDetails.documentPartStatus;
    //this.globalSetting.getAppointmentStatusName(this.commonService.appointmentDetails.appointmentStatusId)
  }

  getStatusBrand(dealerId: string, appointmentId: number, languageCode: string) {
    this.commonService.getStatusBrand(dealerId, appointmentId, languageCode).then(res => {
      if (this.commonService.editAppointmentService.appointmentDetails?.appointmentGuid) {
        this.GetAppointmentDetail(this.commonService.editAppointmentService.appointmentDetails.id, this.commonService.editAppointmentService.appointmentDetails.appointmentGuid);
      }
    })
  }

  async GetAppointmentDetail(Id: number, Guid: string) {
    this.spinner.show();
    this.commonService.GetAppointmentDetail(Id).then((result) => {
      if (result != null) {
        this.onGetContactDetails.emit(result);
      }
      if(this.commonService.mobileCode != null){
        this.onInitSetSellToMobileCode(this.commonService.mobileCode.toString());
      }
    })
  }

  onInitSetSellToMobileCode(dialCode:any){
    if(dialCode[0]==="+")
    {
      dialCode = dialCode.slice(1);
    }
    this.selectedCountryISO = this.getCountryCodeByDialCode(dialCode.toString())
  }

  emitContactData() {
    this.updatedAppointmentDetails.emit(this.commonService.contactDetails);
    this.onGetContactDetails.emit(this.commonService.contactDetails);
  }

  //can not possible to create common function
  async ChangeDealerOfAppoitment() {
    if (this.shiftDealerId?.length > 0) {
      this.spinner.show();
      this.appointmentService.ShiftAppointment(this.shiftDealerId, this.commonService.appointmentDetails.id, this.remark).then((res) => {
        if (res?.responseObject?.isSuccess) {
          let msg = this.translate.instant("lblShiftAppointmentSuccess");
          this.toastr.success(msg);
        }
        else {
          let msg = this.translate.instant("lbldealerisnotworkingforservices");
          this.toastr.warning(msg);
        }
        this.StartDate = null;
        this.workOrderService.BookingDatetime = null;
        this.commonService.DeliveryDate = null;
        this.commonService.FinnishedDate = null;
        this.commonService.deliveryTimeSlot = { hour: 0, minute: 0 };
        this.commonService.finishTimeSlot = { hour: 0, minute: 0 };
        document.getElementById("modelButton").click();
        this.onShiftAppointment.emit();
        // Generate new CheckIn Link
        this.appLinkService.GetCheckInUrl(this.commonService.editAppointmentService.appointmentDetails.appointmentGuid).then(x => {
          this.commonService.editAppointmentService.checkInURL = x?.checkInTinyUrl;
        }, _error => { this.spinner.hide(); })

      }).finally(() => { this.spinner.hide() });
    }
    else {
      let msg = this.translate.instant("lblProvideMandatoryValue");
      this.toastr.error(msg);
    }
  }
  OnHoldStatusChange() {
    const modalref = this.modalService.open(OnholdStatusChangeComponent,
      { size: 'lg', windowClass: 'pop-wid800 ' });
    //if 2 then it is car arrived
    modalref.componentInstance.currentWorkorderStatusId = this.commonService.appointmentDetails.workOrderStatusId;
    modalref.componentInstance.appointmentId = this.commonService.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.workOrderNumber = this.commonService.contactDetails.workOrderNo;
    modalref.result.then((response) => {
      if (response.success && response.isKeepOnHold === true) {
        this.isRefreshTab.emit(true);
        this.resetCalculations()
      }
      else {
        this.resetCalculations()
      }
    }, _error => {
    });
  }
  OnCancelStatusChange() {
    const modalref = this.modalService.open(CancelStatusChangeComponent,
      { size: 'lg', windowClass: 'pop-wid800 ' });
    //if 2 then it is car arrived
    modalref.componentInstance.appointmentId = this.commonService.editAppointmentService.appointmentDetails.id;
    modalref.componentInstance.workOrderNumber = this.commonService.contactDetails.workOrderNo;
    modalref.componentInstance.appointmentType = this.commonService.appointmentDetails.appointmentType;
    modalref.componentInstance.appointmentGuid = this.commonService.editAppointmentService.appointmentDetails.appointmentGuid;
    modalref.componentInstance.brandCode = this.commonService.appointmentDetails.brandCode;
    modalref.result.then((response) => {
      //status update
      if (response.success && response.isKeepOnHold === true) {
        this.isRefreshTab.emit(true);
        this.resetCalculations()
      }
      //remove selected on hold status
      else {
        this.resetCalculations()
      }
    }, _error => {
      // This is intentional
    });
  }

  async onStatusChange() {
    if (this.SelectedStatus != null || this.SelectedStatus != undefined) {
      if (this.SelectedStatus === Enums.WOStatus.Workdone) {
        let isAnyDemand = await this.GetAdditionalServiceDetail();
        if (!isAnyDemand) {
          this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
          this.commonService.SelectedStatus = this.SelectedStatus;
        }
        else {
          let msg = this.translate.instant("lblWorkDoneStatusError");
          this.toastr.error(msg);
          this.SelectedStatus = null;
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.Prepared) {
        if (this.commonService.appointmentDetails.workOrderStatus == Enums.WOStatusName.Cararrived) {
          let modelHeadermsg = this.translate.instant("lblChangeStatus");
          let modelBodymsg = this.translate.instant("lblSureToChangeStatus");
          modelBodymsg = modelBodymsg?.replace('{OldStatus}', this.translate.instant("lblCarArrivedstatus"));
          modelBodymsg = modelBodymsg?.replace('{NewStatus}', this.translate.instant("lblPrepared"));
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
          }, (reason) => {
            if (reason) {
              this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
              this.commonService.SelectedStatus = this.SelectedStatus;
            }
            else {
              this.SelectedStatus = null;
            }
          });
        }
        else {
          this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
          this.commonService.SelectedStatus = this.SelectedStatus;
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.OnHold) {
        if (this.commonService.appointmentDetails.workOrderStatus == Enums.WOStatusName.Mechanicdone) {
          let modelHeadermsg = this.translate.instant("lblChangeStatus");
          let modelBodymsg = this.translate.instant("lblSureToChangeStatus");
          modelBodymsg = modelBodymsg?.replace('{OldStatus}', this.translate.instant("lblMechanicDoneStatus"));
          modelBodymsg = modelBodymsg?.replace('{NewStatus}', this.translate.instant("lblOnHoldStatus"));
          const modalRef = this.modalService.open(NgbdModalContent);
          modalRef.componentInstance.modelHeader = modelHeadermsg;
          modalRef.componentInstance.modelBody = modelBodymsg;
          modalRef.result.then((_result) => {
          }, (reason) => {
            if (reason) {
              this.OnHoldStatusChange();
            }
            else {
              this.SelectedStatus = null;
            }
          });
        }
        else {
          this.OnHoldStatusChange();
        }
      }
      else if (this.SelectedStatus === Enums.WOStatus.Cancelled) {
        this.OnCancelStatusChange()
      }
      else {
        this.commonService.appointmentDetails.workOrderStatusId = this.SelectedStatus;
        this.commonService.SelectedStatus = this.SelectedStatus;
      }
    }
  }

  async GetAdditionalServiceDetail() {
    let isAnyDemand = false;
    const data = await this.appointmentService.GetAdditionalServiceDetail(this.editAppointmentService.appointmentDetails.id);
    if (data.responseObject != null) {
      var appointmentDemandList = data.responseObject.appointmentDemandList;
      if (appointmentDemandList.length > 0) {
        var additionalDemand = appointmentDemandList.filter(x => x.demandNo > 100 && x.isAdditionalWork == true);
        if (additionalDemand.length > 0) {
          var pendingAdditionalDemand = additionalDemand.filter(x => x.isAdminApproved == 0 && x.isCustomerApporved == 0 && x.isMechanicApproved == 0 && x.isCDSSApproved == 0);
          if (pendingAdditionalDemand.length > 0) {
            isAnyDemand = true;
          }
        }
      }
    }
    return isAnyDemand;
  }

  resetCalculations() {
    this.SelectedStatus = null;
    this.commonService.SelectedStatus = null;
    this.commonService.appointmentDetails.workOrderStatusId = this.previousStatus;
  }

  telNomineeInputObject() {
    if (this.commonService.contactDetails.nomineeMobileCode) {
      let countryCode = this.getCountryCodeByDialCode(this.commonService.contactDetails.nomineeMobileCode.toString());
      this.selectedCountryISO = countryCode || this.cultureLocaleService.getLocale();
    }
    else
      this.selectedCountryISO = this.cultureLocaleService.getLocale();
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }

  onNomineeCountryChange(obj) {
    if (this.isInitialLoad) {
      this.telNomineeInputObject();
      this.commonService.contactDetails.nomineeMobileCode = this.commonService.contactDetails.nomineeMobileCode || obj.dialCode;
      this.isInitialLoad = false;
    } else {
      this.commonService.contactDetails.nomineeMobileCode = obj.dialCode;
    }
    this.emitContactData();
  }
  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }
  async UpdateNeedAttention() {
    await this.commonService.UpdateNeedAttention().then((response) => {
      if (response) {
        this.isRefreshTab.emit(true);
      }
    });
  }

  async generateAndSendCheckinLink() {
    if (this.commonService.appointmentBookedDate) {
      await this.appLinkService.SendCheckInSms(this.editAppointmentService.appointmentDetails.id).then(_x => {
        if (_x === "true") {
          let successMessage = this.translate.instant("lblCheckInLinkIsGeneratedAndMessageSent");
          this.toastr.success(successMessage);
        }
        else {
          let failMessage = this.translate.instant("lblFailedToSentCheckInLink");
          this.toastr.error(failMessage);
        }
      }, _error => {
        console.error('HTTP Error', _error);
      })
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }


  }

  generateTrackerLink() {
    if (this.commonService.appointmentBookedDate) {
      if (this.commonService.editAppointmentService.trackerURL) {
        let warningMessage = this.translate.instant("lblTrackerLinkAlreadyGenerated");
        this.toastr.warning(warningMessage);
      }
      else {
        let data = {
          AppointmentGuid: this.commonService.editAppointmentService.appointmentDetails.appointmentGuid
        }
        this.commonService.generateStatusTrackerLink(data);
      }
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
  }

  async generateAndSendTrackerLink() {
    if (this.commonService.appointmentBookedDate) {
      let isTrackerLinkGenerated = false;
      if (!this.commonService.editAppointmentService.trackerURL) {
        let data = {
          AppointmentGuid: this.commonService.editAppointmentService.appointmentDetails.appointmentGuid
        }
        this.commonService.generateStatusTrackerLink(data);
        isTrackerLinkGenerated = true;
      }
      await this.appLinkService.SendTrackerSms(this.editAppointmentService.appointmentDetails.appointmentGuid).then(_x => {
        if (_x === "true" && isTrackerLinkGenerated) {
          let successMessage = this.translate.instant("lblTrackerLinkIsGeneratedAndMessageSent");
          this.toastr.success(successMessage);
        }
        else {
          let failMessage = this.translate.instant("lblFailedToSentTrackerLink");
          this.toastr.error(failMessage);
        }

      }, _error => {
        console.error('HTTP Error', _error);
      })
    }
    else {
      let failedMessage = this.translate.instant("lblPleaseAddAppointmentPlanning");
      this.toastr.error(failedMessage);
    }
  }

  ShiftAppointment(content) {
    let modelHeadermsg = this.translate.instant("lblShiftAppointment");
    let modelBodymsg = this.translate.instant("lblPlanningwillberemoved");
    this.shiftDealerId = '';
    this.remark = '';
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {  // This is intentional
    }, (reason) => {
      let popupCloseResult = this.commonService.getDismissReason(reason);
      if (popupCloseResult) {
        this.commonService.getUserDealers();
        this.commonService.ConfirmShiftAppoitment(content)
      }
    });
  }

  onDealerChange(event) { this.shiftDealerId = event; }

  onChangePhoneNo() {
    this.commonService.contactDetails.singlePhoneNo = this.commonService.contactDetails.singlePhoneNo?.number?.number ? this.commonService.contactDetails.singlePhoneNo.number.number.toString().replace(/\s+/g, '') : this.commonService.contactDetails.singlePhoneNo?.number;
  }
}
